import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchMailStats, fetchMailsByStatus } from "../api/mailApi";
import { AUTH_STORAGE_KEY } from "../socket";
import MailPreview from "../components/mail/MailPreview";

function DashboardPage({ onReply, onReplyAll, onForward, onDeleteMail, onOpenComposeModal }) {
  const [stats, setStats] = useState({ total: 0, sent: 0, open: 0,  inProgress: 0,closed: 0 });
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState(null); // 'Open' | 'Closed' | null
  const [statusMails, setStatusMails] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);
  const [showMail, setShowMail] = useState(false);
  const [previewMail, setPreviewMail] = useState(null);
  const navigate = useNavigate();

  const fetchStatusMails = async (status) => {
    setStatusLoading(true);
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const headers = parsed?.token ? { Authorization: `Bearer ${parsed.token}` } : null;
      const res = await fetchMailsByStatus(status, headers);
      setStatusMails(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("Failed to load mails for status", err);
      setStatusMails([]);
    } finally {
      setStatusLoading(false);
    }
  };


  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setLoading(true);
      try {
        const raw = localStorage.getItem(AUTH_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        const headers = parsed?.token ? { Authorization: `Bearer ${parsed.token}` } : null;
        const res = await fetchMailStats(headers);
        if (!mounted) return;
        setStats({ total: Number(res.total) || 0, sent: Number(res.sent) || 0, open: Number(res.open) || 0, inProgress: Number(res.inProgress) || 0, closed: Number(res.closed) || 0 });
      } catch (err) {
        console.error("Failed to load dashboard stats", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, []);

  const { total, sent, open, inProgress,closed } = stats;
  const sumOpenClosed = Math.max(open + closed, 1);
  const sumStatus = Math.max(open + inProgress + closed, 1);

  const openPerc = Math.round((open / sumOpenClosed) * 100);
  const closedPerc = Math.round((closed / sumOpenClosed) * 100);
const inProgressPerc = Math.round((inProgress / sumStatus) * 100);

  return (
    <section className="mail-dashboard">
      <h2 className="page-title">Dashboard</h2>

      {loading ? (
        <div className="dashboard-loading">Loading...</div>
      ) : (
        <>
          <div className="dashboard-grid">
            <div
              className="stat-card"
              role="button"
              tabIndex={0}
              aria-label="Total mail"
              onClick={() => navigate("/kmail/all")}
              onKeyDown={(e) => { if (e.key === "Enter") navigate("/kmail/all"); }}
              style={{ background: "linear-gradient(135deg,#7c3aed,#60a5fa)" }}
            >
              <div className="stat-card-icon"><i className="fa-solid fa-envelope-open-text"></i></div>
              <div className="stat-card-body">
                <div className="stat-card-label">Total Mail</div>
                <div className="stat-card-value">{total}</div>
              </div>
            </div>

            <div
              className="stat-card"
              role="button"
              tabIndex={0}
              aria-label="Sent mail"
              onClick={() => navigate("/kmail/sent")}
              onKeyDown={(e) => { if (e.key === "Enter") navigate("/kmail/sent"); }}
              style={{ background: "linear-gradient(135deg,#10b981,#06b6d4)" }}
            >
              <div className="stat-card-icon"><i className="fa-solid fa-paper-plane"></i></div>
              <div className="stat-card-body">
                <div className="stat-card-label">Sent Mail</div>
                <div className="stat-card-value">{sent}</div>
              </div>
            </div>

         

            <div
              className="stat-card"
              role="button"
              tabIndex={0}
              aria-label="Open status"
              onClick={async () => {
                if (selectedStatus === 'Open') {
                  setSelectedStatus(null);
                  setStatusMails([]);
                } else {
                  setSelectedStatus('Open');
                  await fetchStatusMails('Open');
                }
              }}
              onKeyDown={async (e) => { if (e.key === "Enter") { if (selectedStatus === 'Open') { setSelectedStatus(null); setStatusMails([]); } else { setSelectedStatus('Open'); await fetchStatusMails('Open'); } } }}
              style={{ background: "linear-gradient(135deg,#f59e0b,#f97316)" }}
            >
              <div className="stat-card-icon"><i className="fa-solid fa-circle-notch"></i></div>
              <div className="stat-card-body">
                <div className="stat-card-label">Open</div>
                <div className="stat-card-value">{open}</div>
              </div>
            </div>
              <div
              className="stat-card"
              role="button"
              tabIndex={0}
              aria-label="In Progress status"
              onClick={async () => {
                if (selectedStatus === 'In Progress') {
                  setSelectedStatus(null);
                  setStatusMails([]);
                } else {
                  setSelectedStatus('In Progress');
                  await fetchStatusMails('In Progress');
                }
              }}
              onKeyDown={async (e) => { if (e.key === "Enter") { if (selectedStatus === 'In Progress') { setSelectedStatus(null); setStatusMails([]); } else { setSelectedStatus('In Progress'); await fetchStatusMails('In Progress'); } } }}
              style={{ background: "linear-gradient(135deg, rgb(245 11 245), rgb(142 29 148))" }}
            >
              <div className="stat-card-icon"><i className="fa-solid fa-circle-notch"></i></div>
              <div className="stat-card-body">
                <div className="stat-card-label">In Progress</div>
                <div className="stat-card-value">{inProgress}</div>
              </div>
            </div>

            <div
              className="stat-card"
              role="button"
              tabIndex={0}
              aria-label="Closed status"
              onClick={async () => {
                if (selectedStatus === 'Closed') {
                  setSelectedStatus(null);
                  setStatusMails([]);
                } else {
                  setSelectedStatus('Closed');
                  await fetchStatusMails('Closed');
                }
              }}
              onKeyDown={async (e) => { if (e.key === "Enter") { if (selectedStatus === 'Closed') { setSelectedStatus(null); setStatusMails([]); } else { setSelectedStatus('Closed'); await fetchStatusMails('Closed'); } } }}
              style={{ background: "linear-gradient(135deg,#ef4444,#f43f5e)" }}
            >
              <div className="stat-card-icon"><i className="fa-solid fa-lock"></i></div>
              <div className="stat-card-body">
                <div className="stat-card-label">Closed</div>
                <div className="stat-card-value">{closed}</div>
              </div>
            </div>
          </div>

          <div className="dashboard-chart-shell">
            <div className="dashboard-chart-header">
              <div className="chart-title">Open vs Closed</div>
              <div className="chart-legend">
                <span className="legend-item"><span className="legend-dot open"></span> Open ({open})</span>
                <span className="legend-item"><span className="legend-dot in-progress"></span> In Progress ({inProgress})</span>
                <span className="legend-item"><span className="legend-dot closed"></span> Closed ({closed})</span>
              </div>
            </div>
            <div className="dashboard-chart">
              <div className="dashboard-bar">
                <div className="bar-segment open" style={{ width: `${openPerc}%` }} />
                <div className="bar-segment in-progress" style={{ width: `${inProgressPerc}%` }} />
                <div className="bar-segment closed" style={{ width: `${closedPerc}%` }} />
              </div>
              <div className="dashboard-chart-stats">
                <div>{openPerc}% Open</div>
                  <div>{inProgressPerc}% In Progress</div>
                <div>{closedPerc}% Closed</div>
              </div>
            </div>
          </div>

          {/* Inline status table */}
          {selectedStatus && (
            <div className="dashboard-status-list">
              <div className="status-list-header">
                <h3>{selectedStatus} mails</h3>
                <div>
                  <button className="mail-top-btn secondary" onClick={() => { setSelectedStatus(null); setStatusMails([]); }}>Close</button>
                </div>
              </div>

              {statusLoading ? (
                <div>Loading...</div>
              ) : (
                <table className="status-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>From</th>
                      <th>Subject</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statusMails.length === 0 && (
                      <tr><td colSpan={4}>No messages</td></tr>
                    )}
                    {statusMails.map((m) => (
                      <tr key={m.id}>
                        <td>{m.sentAt ? new Date(m.sentAt).toLocaleString() : ''}</td>
                        <td>{m.from}</td>
                        <td>
                          <button className="link-like" onClick={() => { setPreviewMail(m); setShowMail(true); }}>{m.subject || '(No subject)'}</button>
                        </td>
                        <td>
                          <button className="mail-top-btn" onClick={() => { setPreviewMail(m); setShowMail(true); }}>Open</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}

          {showMail && previewMail && (
            <div className="modal-overlay" role="dialog" aria-modal="true" onClick={() => setShowMail(false)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h3>{previewMail.subject || 'Message'}</h3>
                  <button onClick={() => setShowMail(false)}>×</button>
                </div>
                <div className="modal-body">
                  <MailPreview
                    mail={previewMail}
                    onOpenComposeModal={onOpenComposeModal}
                    onDelete={(id) => {
                      // prefer parent handler if provided, otherwise fallback to local removal
                      try { onDeleteMail?.(id || previewMail?.id); } catch (e) {}
                      setShowMail(false);
                      // remove from inline list if present
                      setStatusMails((prev) => (Array.isArray(prev) ? prev.filter((x) => String(x.id) !== String(id || previewMail?.id)) : prev));
                    }}
                   onReply={() => {
  if (!previewMail?.from || !previewMail?.from.includes("@")) {
    alert("Reply not available: sender email missing");
    return;
  }
  onReply?.({
    ...previewMail,
    from: previewMail.from
  });
}}
                    onReplyAll={() => { onReplyAll?.(previewMail); }}
                    onForward={() => { onForward?.(previewMail); }}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </section>
  );
}

export default DashboardPage;
